import {Switch, alpha} from '@mui/material'
import {common, green} from '@mui/material/colors'
import styled from 'styled-components'

export const GreenSwitch = styled(Switch)(({theme}) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: common.white,
    '&:hover': {
      backgroundColor: alpha(common.white, 5),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: green[900],
  },
}))

export const ContainerBoxes = styled.div`
  background-color: white;
  border-radius: 8px;
  position: relative;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
`
